module.exports = __webpack_public_path__ + "img/5.bfe9c6a0.png";